import GoogleMapsLoader from 'google-maps'
import throttle from 'lodash/throttle'

import Component from '../core/Component'
import { GOOGLE_MAPS_API_KEY } from '../core/config'
import { createMarker } from './Marker'

GoogleMapsLoader.KEY = GOOGLE_MAPS_API_KEY

export const defaults = {
    zoom: 16,
    styles: [
        { featureType: 'all', elementType: 'all', stylers: [{ visibility: 'off' }] },
        {
            featureType: 'administrative.country',
            elementType: 'geometry.stroke',
            stylers: [{ color: '#8aa49f' }, { visibility: 'on' }],
        },
        {
            featureType: 'administrative.province',
            elementType: 'all',
            stylers: [{ visibility: 'on' }],
        },
        {
            featureType: 'administrative.locality',
            elementType: 'all',
            stylers: [{ visibility: 'on' }],
        },
        {
            featureType: 'administrative.neighborhood',
            elementType: 'all',
            stylers: [{ visibility: 'on' }],
        },
        { featureType: 'landscape', elementType: 'geometry', stylers: [{ visibility: 'on' }] },
        { featureType: 'landscape.natural', elementType: 'all', stylers: [{ visibility: 'on' }] },
        {
            featureType: 'landscape.natural',
            elementType: 'geometry',
            stylers: [{ visibility: 'on' }, { gamma: '3.32' }],
        },
        {
            featureType: 'landscape.natural.landcover',
            elementType: 'all',
            stylers: [{ visibility: 'off' }],
        },
        {
            featureType: 'landscape.natural.landcover',
            elementType: 'geometry',
            stylers: [{ visibility: 'off' }],
        },
        {
            featureType: 'landscape.natural.terrain',
            elementType: 'all',
            stylers: [{ visibility: 'off' }],
        },
        { featureType: 'poi', elementType: 'all', stylers: [{ visibility: 'off' }] },
        { featureType: 'poi', elementType: 'geometry', stylers: [{ visibility: 'simplified' }] },
        { featureType: 'road', elementType: 'geometry', stylers: [{ visibility: 'on' }] },
        { featureType: 'road', elementType: 'labels.text', stylers: [{ visibility: 'on' }] },
        { featureType: 'transit.station', elementType: 'all', stylers: [{ visibility: 'on' }] },
        { featureType: 'water', elementType: 'geometry', stylers: [{ visibility: 'on' }] },
    ],
}

export default class GoogleMap extends Component {
    constructor(element) {
        super(element, defaults)

        this.latlng = null
        this.isReady = false

        this.handleResize = throttle(this.handleResize, 200)
    }

    prepare() {
        GoogleMapsLoader.load(this.render)
        window.addEventListener('resize', this.handleResize)
    }

    destroy() {
        window.removeEventListener('resize', this.handleResize)
        this.map = null
    }

    handleResize = () => {
        this.center()
    }

    render = (google) => {
        const latlng = new google.maps.LatLng(this.options.lat, this.options.lng)
        this.google = google
        this.latlng = latlng

        this.map = new google.maps.Map(this.element, {
            center: latlng,
            zoom: this.options.zoom,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: this.options.styles,
            disableDefaultUI: this.options.disableDefaultUI ? this.options.disableDefaultUI : false,
            gestureHandling: 'cooperative',
        })

        const Marker = createMarker(google)

        if (Array.isArray(this.options.multiplePoints)) {
            this.options.multiplePoints.forEach(point => {
                new Marker({
                    position: new google.maps.LatLng(point.lat, point.lng),
                    className: "Marker Marker--side",
                    map: this.map,
                    title: point.name,
                    template: `
                        <div class="Marker-popup">
                            <h2>${point.name}</h2>
                            <p>${point.description ? point.description : ''}</p>
                        </div>
                    `,
                    onClick: function (markerInstance) {
                        const marker = markerInstance.element

                        if (!marker) return

                        const isAlreadyOpen = marker.classList.contains("Marker--show");

                        document.querySelectorAll('.Marker').forEach(p => {
                            p.classList.remove("Marker--show");
                        });

                        if (!isAlreadyOpen) {
                            marker.classList.add("Marker--show");
                            markerInstance.draw()
                        } else {
                            markerInstance.draw()
                        }
                    }
                })
            })
        }

        const pin = new Marker({
            position: latlng,
            map: this.map,
        })

        setTimeout(() => {
            this.isReady = true
            this.center()
        }, 100)
    }

    center() {
        if (this.isReady) {
            this.google.maps.event.trigger(this.map, 'resize')
            this.map.setCenter(this.latlng)

            if(this.options.offsetX != undefined && this.options.offsetY != undefined && window.innerWidth >= 1024) {
                this.map.panBy(this.options.offsetX, this.options.offsetY)
            }
        }
    }
}
